import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../utils/ApiManager';
import { clearTokens } from '../utils/tokenService';
import Navbar from '../components/Navbar';
import HeroHeader from '../components/HeroHeader';
import Features from '../components/Features';
import Gallery from '../components/Gallery';
import Testimonials from '../components/Testimonials';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import HorizontalTimelineWorkflows from '../components/HorizontalTimelineWorkflow';

const HomePage = () => {
  const [user, setUser] = useState(null);
  const [loggedIn, setLoggedIn] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/api/auth/me')
        .then((response) => {
          setUser(response.data.user);
          setLoggedIn(true);
        })
        .catch((err) => {
          console.error('Error fetching profile:', err);
          setLoggedIn(false);
        });
    } else {
      setLoggedIn(false);
    }
  }, []);

  const handleLogout = () => {
    clearTokens();
    setUser(null);
    setLoggedIn(false);
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="fixed left-4 top-[300px] bg-yellow-500 py-2 px-4 rotate-[-90deg] origin-left text-white shadow-md z-50 font-semibold">
        Under development
      </div>
      <Navbar user={user} />
      
      {/* Success Message */}
      {location.state?.message && (
        <div className={`fixed top-24 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-md`}>
          <div className={`mx-4 p-4 rounded-lg shadow-lg ${
            location.state.type === 'success' 
              ? 'bg-green-100 border border-green-200 text-green-800'
              : 'bg-red-100 border border-red-200 text-red-800'
          }`}>
            <p className="text-center">{location.state.message}</p>
          </div>
        </div>
      )}
      
      <section id="home">
        <HeroHeader>
          {!user && (
            <Link
              to="/register"
              className="mt-8 px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 inline-block"
            >
              Get Started
            </Link>
          )}
        </HeroHeader>
      </section>
      <section id="features">
        <Features />
      </section>
      <section id="how-we-work">
      <HorizontalTimelineWorkflows />
      </section>
      <section id="gallery">
        <Gallery />
      </section>
      <section id="testimonials">
        <Testimonials />
      </section>
      <section id="pricing">
        <Pricing />
      </section>
      <section id="faq">
        <FAQ />
      </section>
      <CTA>
        {!user && (
          <Link
            to="/register"
            className="mt-8 px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 inline-block"
          >
            Get Started Now
          </Link>
        )}
      </CTA>
      <Footer />
    </div>
  );
};

export default HomePage;